'use client'

// List each pictogram SVG file here

export { default as ActivitiesPictogram } from './catalog/Activities'
export { default as AwardPictogram } from './catalog/Award'
export { default as BenefitsConnectPictogram } from './catalog/BenefitsConnect'
export { default as BenefitsEventsPictogram } from './catalog/BenefitsEvents'
export { default as BenefitsTipsPictogram } from './catalog/BenefitsTips'
export { default as BookPictogram } from './catalog/Book'
export { default as CelebrationPictogram } from './catalog/Celebration'
export { default as CommunityManagmentPictogram } from './catalog/CommunityManagment'
export { default as DialogPictogram } from './catalog/Dialog'
export { default as EventPictogram } from './catalog/Event'
export { default as ExpatGuidesPictogram } from './catalog/ExpatGuides'
export { default as FriendsPictogram } from './catalog/Friends'
export { default as GenderPictogram } from './catalog/Gender'
export { default as GlobePictogram } from './catalog/Globe'
export { default as HousePictogram } from './catalog/House'
export { default as MeetingPictogram } from './catalog/Meeting'
export { default as NetworkPictogram } from './catalog/Network'
export { default as IDPictogram } from './catalog/ID'
export { default as PaperPlanePictogram } from './catalog/PaperPlane'
export { default as PhotosPictogram } from './catalog/Photos'
export { default as QualityPictogram } from './catalog/Quality'
export { default as SupportPictogram } from './catalog/Support'
export { default as ThumbsUpPictogram } from './catalog/ThumbsUp'
export { default as EmailPictogram } from './catalog/Email'
export { default as BellNotificationPictogram } from './catalog/BellNotification'
export { default as NetworkingPictogram } from './catalog/Networking'
export { default as AlbatrossUspPictogram } from './catalog/AlbatrossUSP'
export { default as PresentPictogram } from './catalog/Present'
export { default as LanguagePictogram } from './catalog/Language'
export { default as JobsPictogram } from './catalog/Jobs'
export { default as BusinessContactsPictogram } from './catalog/BusinessContacts'
export { default as BusinessPictogram } from './catalog/Business'
export { default as TravelPictogram } from './catalog/Travel'
export { default as NewRelationshipPictogram } from './catalog/NewRelationship'
export { default as ParentsPictogram } from './catalog/Parents'
export { default as InfoPictogram } from './catalog/Info'
